import type { CohortNames, IAbTestingState } from '@bridebook/toolbox/src/ab-testing/lib/types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export const initialState: IAbTestingState = {
  abTests: {},
  abTestsLoaded: false,
  abTestsLifecycleState: {},
};

export const abTestingSlice = createSlice({
  name: 'abTesting',
  initialState,
  reducers: {
    setAbTestVariant(state, action: PayloadAction<{ id: string; variant: CohortNames }>) {
      const { id, variant } = action.payload;
      state.abTests[id] = variant;
    },
    setAbTestsLoaded(state, action: PayloadAction<boolean>) {
      state.abTestsLoaded = action.payload;
    },
    markAbTestAsLoading(state, action: PayloadAction<string>) {
      const testId = action.payload;
      const current = state.abTestsLifecycleState[testId];
      if (!current || current.status === 'skipped') {
        state.abTestsLifecycleState[testId] = { status: 'loading', variant: null };
      }
    },
    markAbTestAsLoaded(state, action: PayloadAction<{ id: string; variant: CohortNames }>) {
      const { id, variant } = action.payload;
      state.abTestsLifecycleState[id] = { status: 'loaded', variant };
    },
    markAbTestAsError(state, action: PayloadAction<string>) {
      const testId = action.payload;
      state.abTestsLifecycleState[testId] = { status: 'error', variant: 'control' };
    },
    markAbTestAsSkipped(state, action: PayloadAction<string>) {
      const testId = action.payload;
      state.abTestsLifecycleState[testId] = { status: 'skipped', variant: 'control' };
    },
  },
});

export const {
  setAbTestVariant,
  setAbTestsLoaded,
  markAbTestAsLoading,
  markAbTestAsLoaded,
  markAbTestAsError,
  markAbTestAsSkipped,
} = abTestingSlice.actions;
export default abTestingSlice.reducer;
